import { render, staticRenderFns } from "./xmyjxjs.vue?vue&type=template&id=172df79f&scoped=true"
import script from "./xmyjxjs.vue?vue&type=script&lang=js"
export * from "./xmyjxjs.vue?vue&type=script&lang=js"
import style0 from "./xmyjxjs.vue?vue&type=style&index=0&id=172df79f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172df79f",
  null
  
)

export default component.exports